import { newStreamTracker } from '@npotag/tag';
import { bindPlayerEvents } from './eventbinding';
import { validatePrid } from '../../utilities/utilities.stream';
export function startPlayerTracker(playerInstance, duration, version, source) {
    playerInstance.streamTracker = undefined;
    let streamTrackerConfig = undefined;
    if (playerInstance.npoTag?.pageTracker == undefined) {
        console.error('No pageTracker available');
    }
    else {
        streamTrackerConfig = {
            stream_length: duration,
            stream_id: validatePrid(source),
            player_id: 'npoplayer-web',
            av_type: playerInstance.npoplayerServices.getAVType(playerInstance.streamObject.stream.avType),
            player_version: version,
            sko_player_version: '1.0.0'
        };
        const isLiveStream = playerInstance.streamObject.stream.isLiveStream || false;
        playerInstance.streamTracker = newStreamTracker(playerInstance.npoTag.pageTracker, streamTrackerConfig, {
            isLive: isLiveStream
        });
        bindPlayerEvents(playerInstance, playerInstance.player);
    }
}
